/**
 * @generated SignedSource<<22c7552c4fd96acec128093140906b23>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AssetAssignmentTypesPanel_addAssignmentTypesToAssetMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "AddAssignmentTypesToAssetPayload",
                    "kind": "LinkedField",
                    "name": "addAssignmentTypesToAsset",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "asset",
                            "plural": false,
                            "selections": [
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "AssetAssignmentTypesPanel_asset"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AssetAssignmentTypesPanel_addAssignmentTypesToAssetMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "AddAssignmentTypesToAssetPayload",
                    "kind": "LinkedField",
                    "name": "addAssignmentTypesToAsset",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "asset",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AssignmentTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "assignmentTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "AssignmentType",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "title",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                (v2 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "c4458666ca50f8006098108983cfc2e6",
            "id": null,
            "metadata": {},
            "name": "AssetAssignmentTypesPanel_addAssignmentTypesToAssetMutation",
            "operationKind": "mutation",
            "text": "mutation AssetAssignmentTypesPanel_addAssignmentTypesToAssetMutation(\n  $model: AddAssignmentTypesToAssetInput!\n) {\n  addAssignmentTypesToAsset(model: $model) {\n    asset {\n      ...AssetAssignmentTypesPanel_asset\n      id\n    }\n  }\n}\n\nfragment AssetAssignmentTypesPanel_asset on Asset {\n  assignmentTypes {\n    nodes {\n      id\n      title\n    }\n  }\n  id\n}\n"
        }
    };
})();
node.hash = "0b8975cb41ac34a5fcaa0cea65c52589";
export default node;
